const getMenuItems = (permissions) => [
  {
    key: "home",
    url: "/home",
    // icon: "icon icon-home",
    title: "Anasayfa",
    style: { color: "white" },
    children: [
      {
        key: "home-stock",
        url: "/home-stock",
        icon: "icon icon-revenue-new",
        title: "Stok",
        module: 1,
      },
    ],
  },
  {
    key: "firms",
    // icon: "icon icon-company",
    title: "Proje İşlemleri",
    children: [
      {
        key: "firm-list",
        url: "/firm-list",
        icon: "icon icon-all-contacts",
        title: "Proje Listesi",
      },
      // {
      //   key: "firm-account-list",
      //   url: "/firm-account-list",
      //   icon: "icon icon-anchor",
      //   title: "Proje Hesapları",
      // },
    ],
  },

  // {
  //   key: "employees",
  //   // icon: "icon icon-company",
  //   title: "Personel Takip",
  //   module: 13,
  //   children: [
  //     {
  //       key: "employee-list",
  //       url: "/employee-list",
  //       icon: "icon icon-all-contacts",
  //       title: "Personel Listesi",
  //     },
  //     {
  //       key: "employee-transaction-report",
  //       url: "/employee-transaction-report",
  //       icon: "icon icon-company",
  //       title: "Personel Maaş Hareketleri Raporu",
  //     },
  //   ],
  // },
  {
    key: "stocks",
    title: "Depo-Stok",
    module: 14,
    children: [
      {
        key: "transaction-project-type",
        url: "/transaction-project-type",
        icon: "icon icon-all-contacts",
        title: "Depo Listesi",
      },
      {
        key: "stock-list",
        url: "/stock-list",
        icon: "icon icon-all-contacts",
        title: "Ürün Listesi",
      },
      {
        key: "stock-report",
        icon: "icon icon-data-display",
        title: "Raporlar",
        children: [
          {
            key: "stock-price-history-report",
            url: "/stock-price-history-report",
            icon: "icon icon-company",
            title: "Ürün Fiyat Geçmişi Raporu",
          },
          {
            key: "stock-movement-history-report",
            url: "/stock-movement-history-report",
            icon: "icon icon-all-contacts",
            title: "Stok Hareketleri Raporu",
          },
          {
            key: "storage-stock-report",
            url: "/storage-stock-report",
            icon: "icon icon-all-contacts",
            title: "Depo-Stok Raporu",
          },
        ],
      },
    ],
  },
  {
    key: "purchaseRequest",
    //icon: "icon icon-company",
    title: "Satın Alma",
    module: 18,
    children: [
      {
        key: "purchsae-request-list",
        icon: "icon icon-company",
        title: "Talep Listesi",
        url: "/purchase-request-list",
        url: "/purchase-request-list",
      },
      {
        key: "quote-list",
        icon: "icon icon-company",
        title: "Teklif Listesi",
        url: "/quote-list",
        url: "/quote-list",
      },
      {
        key: "order-list",
        icon: "icon icon-company",
        title: "Sipariş Listesi",
        url: "/order-list",
        url: "/order-list",
      },
      {
        key: "order-delivery-list",
        icon: "icon icon-company",
        title: "Teslimat Kaydı Listesi",
        url: "/order-delivery-list",
        url: "/order-delivery-list",
      },
    ],
  },
  {
    key: "supplierAndMaterial",
    // icon: "icon icon-company",
    title: "Tedarikçi",
    module: 19,
    children: [
      {
        key: "supplier-list",
        url: "/supplier-list",
        icon: "icon icon-all-contacts",
        title: "Tedarikçi-Taşeron Listesi",
      },
    ],
  },

  {
    key: "setting",
    // icon: "icon icon-setting",
    title: "Ayarlar",
    isRender: permissions.isAdmin,
    children: [
      {
        key: "user-list",
        url: "/user-list",
        icon: "icon icon-all-contacts",
        title: "Kullanıcı Listesi",
      },
      {
        key: "material-category-list",
        url: "/material-cateogry-list",
        icon: "icon icon-anchor",
        title: "Kategori Listesi",
      },
      {
        key: "tenant-parameter",
        url: "/tenant-parameter",
        icon: "icon icon-setting",
        title: "Firma Ayarları",
      },
    ],
  },
];

export default getMenuItems;
